export default "__VITE_ASSET__BiBkgYwK__"